import { useTranslation } from 'react-i18next'
import { setLocale as persistLocale } from './i18n'

const EN_TEXT: Record<string, string> = {
  '退出': 'Log out',
  '刷新': 'Refresh',
  '搜索': 'Search',
  '清除': 'Clear',
  '加载中…': 'Loading...',
  '暂无数据': 'No data',
  '开发中': 'In development',
  '未配置模块': 'Unconfigured module',
  '上一页': 'Previous',
  '下一页': 'Next',
  '用户': 'users',
  '活跃': 'Active',
  '已禁用': 'Disabled',
  '邀请测试': 'Invited tester',
  '邀请/测试': 'Invited / test',
  '公开测试': 'Public Beta',
  '历史账号': 'Legacy account',
  '管理员': 'Admin',
  '启用': 'Enable',
  '禁用': 'Disable',
  '设为管理员': 'Make admin',
  '降为普通用户': 'Demote to user',
  '标记测试不占名额': 'Mark test, exclude from slots',
  '恢复公开名额': 'Restore public slot',
  '当前': 'Current',
  '待处理': 'Pending',
  '已处理': 'Resolved',
  '未处理': 'Open',
  '已完成': 'Done',
  '已忽略': 'Ignored',
  '未完成任务': 'Active tasks',
  '全部任务': 'All tasks',
  '刷新中…': 'Refreshing...',
  '创建中…': 'Creating...',
  '保存中…': 'Saving...',
  '检查中…': 'Checking...',
  '检查平台版本': 'Check store versions',
  '保存状态': 'Save status',
  '分层运行': 'Layered',
  '剩余名额': 'Slots remaining',
  '动作': 'Action',
  '治理动作': 'Governance action',
  '未处理 blocking issue。': 'Open blocking issues.',
  '暂无 Coverage Matrix 数据': 'No Coverage Matrix data',
  'Overview': 'Overview',
  'Source Layer': 'Source Layer',
  'Evidence Layer': 'Evidence Layer',
  'Review Layer': 'Review Layer',
  'Policy Layer': 'Policy Layer',
  '是': 'Yes',
  '否': 'No',
  '高': 'High',
  '中': 'Medium',
  '低': 'Low',

  '运营概览': 'Ops Overview',
  '公测监控': 'Beta Monitor',
  '账号权限': 'Accounts',
  '注册与邀请': 'Registration & Invites',
  '用户管理': 'Users',
  '邀请码': 'Invite code',
  '数据观察': 'Analytics',
  '系统状态': 'System Status',
  'KNE 审核': 'KNE Review',
  '来源运营': 'Source Ops',
  '平台适配': 'Platform Ops',
  '平台': 'Platform',
  '操作': 'Action',
  '用户列表': 'Users',
  '邮箱': 'Email',
  '方案': 'Plan',
  '角色': 'Role',
  '来源': 'Source',
  '来源类型': 'Source type',
  '质量门槛': 'Quality gate',
  '复核路径': 'Review path',
  '复核备注': 'Review note',
  '处理备注（可选）': 'Review note (optional)',
  '处理时间': 'Reviewed at',
  '可信状态': 'Trust state',
  '二次复核': 'Second review',
  '复核历史': 'Review history',
  '状态历史': 'Status history',
  '状态': 'Status',
  '目标版本': 'Target version',
  '人工状态': 'Manual status',
  '平台已发布': 'Published by store',
  '核对结果': 'Comparison',
  '平台未公开版本': 'Version not exposed by platform',
  '检查失败': 'Check failed',
  '目标版本已上线': 'Target version is live',
  '目标版本尚未上线': 'Target version is not live',
  '仅保留人工记录': 'Manual record only',
  '状态未知': 'Status unknown',
  '人工审核记录与平台公开已发布版本分开显示；网络失败不会被判断为未发布。': 'Manual review records and publicly released store versions are shown separately. Network failures are not treated as unpublished.',
  '草稿': 'Draft',
  '已复核草稿': 'Reviewed draft',
  '二审通过候选': 'Second-review passed candidate',
  '已拒绝': 'Rejected',
  '证据不足': 'Evidence insufficient',
  '待复核': 'Needs review',
  '高风险': 'High risk',
  '存在冲突': 'Conflicted',
  '可能过期': 'May be outdated',
  '非知识内容': 'Not knowledge content',
  '注册时间': 'Registered',
  '搜索邮箱…': 'Search email...',
  '总用户': 'Total users',
  '总账号（含测试）': 'Total accounts (including test)',
  '可用账号（含测试）': 'Enabled accounts (including test)',
  '新增 7d': 'New 7d',
  '时间范围：': 'Range:',
  '新增用户': 'New users',
  'Verify 次数': 'Verify count',
  'Verify': 'Verify',
  '来源支持': 'Source supported',
  '非知识': 'Not knowledge',
  '反馈复制': 'Feedback copied',
  '反馈提交': 'Feedback submitted',
  '贡献提交': 'Contribution submitted',
  '阻断问题': 'Blocking issues',
  '商店状态': 'Store status',
  '每日数据明细': 'Daily metrics',
  '日期': 'Date',
  '邀请码总数': 'Invite codes',
  '可用': 'Available',
  '已用完': 'Exhausted',
  '已注册用户': 'Registered users',
  '邀请码列表': 'Invite Codes',
  '+ 新建': '+ New',
  '取消': 'Cancel',
  '随机生成': 'Random',
  '自定义': 'Custom',
  '生成数量': 'Quantity',
  '次数上限（-1=无限）': 'Use limit (-1 = unlimited)',
  '备注（可选）': 'Note (optional)',
  '确认创建': 'Create',
  '搜索来源': 'Search source',
  '上限': 'Limit',
  '已用': 'Used',
  '剩余': 'Remaining',
  '备注': 'Note',
  '创建时间': 'Created',
  '删除': 'Delete',
  '邀请码详情': 'Invite Code Details',
  '次数上限': 'Use limit',
  '已使用': 'Used',
  '过期时间': 'Expires',
  '无限制': 'Unlimited',
  '永不过期': 'Never expires',
  '暂无': 'None',
  '复核队列': 'Review Queue',
  '来源库维护': 'Source Registry',
  '优先维护权威来源、来源类型、适用学科和失效风险。旧 Knowledge 只作为 Reference Corpus，不直接升级为认证知识。': 'Maintain authoritative sources, source types, applicable councils, and freshness risks first. Legacy Knowledge remains Reference Corpus and is not directly upgraded into certified knowledge.',
  '当前显示': 'Displayed',
  '可支持主张': 'Can support claims',
  '需复核': 'Needs review',
  '候选来源': 'Candidate sources',
  '全部类型': 'All types',
  '全部权威等级': 'All authority levels',
  '暂无来源注册项。': 'No source registry entries.',
  '暂无已通过的候选来源。': 'No accepted candidate sources.',
  '可信状态规则': 'Trust State Rules',
  '系统边界检查': 'System Boundary Check',
  '旧 Spark Chat 不作为主入口，只保留 fallback / retired route 说明。': 'Legacy Spark Chat is not the main entry; only fallback / retired route notes remain.',
  '本地使用 .env，线上使用 K8s Secret；Secret 不写入文档或 Git。': 'Local uses .env; online uses K8s Secret. Secrets are not written to docs or Git.',
  '用户私有知识殿堂不混入 KNE 主数据。': 'User private knowledge halls do not mix into KNE core data.',
  'Spark 输出可信状态和证据缺口，不宣称完整认证真理。': 'Spark outputs trust states and evidence gaps; it does not claim complete truth certification.',
  '本后台只处理用户、注册、用量、日志、成本和系统状态。': 'This admin handles users, registration, usage, logs, costs, and system status only.',
  'Spark 运营后台': 'Spark Operations Admin',
  '管理公开测试、用户、使用量、日志、成本和 Chrome Web Store 状态。KNE 贡献审核、来源库和可信策略迁移到 /kneadmin。': 'Manage public beta, users, usage, logs, costs, and Chrome Web Store status. KNE contribution review, source registry, and trust policy have moved to /kneadmin.',
  '运营边界': 'Operational Boundary',
  '注册状态': 'Registration status',
  '剩余普通公开注册名额': 'ordinary public registration slots remaining.',
  'Open': 'Open',
  'Closed': 'Closed',
  'Monitor': 'Monitor',
  '总账号': 'Total accounts',
  '公开注册': 'Public registration',
  'Chrome Web Store 审核状态': 'Chrome Web Store review status',
  '当前状态': 'Current status',
  '更新时间': 'Updated at',
  '更新人': 'Updated by',
  'Chrome Web Store 审核备注': 'Chrome Web Store review note',
  'draft': 'Draft',
  'submitted': 'Submitted',
  'in_review': 'In review',
  'approved': 'Approved',
  'rejected': 'Rejected',
  'paused': 'Paused',
  '公开测试注册': 'Public beta registrations',
  '目标 AI 用户': 'Target AI users',
  '激活率': 'Activation rate',
  '7 天二次验证率': '7-day repeat verify rate',
  '人均 7 天 Verify': 'Avg 7-day Verify',
  '匿名试用 Verify': 'Anonymous trial Verify',
  '格式为 Verify 次数 / 匿名安装数；不计入 200 名额、注册激活或留存。': 'Format is Verify count / anonymous installs; not counted in the 200-user cap, registration activation, or retention.',
  '官网安装点击': 'Homepage install clicks',
  '官网安装入口的聚合点击量；只记录语言、入口位置和活动标签，不记录选中文本或账号标识。': 'Aggregate clicks on homepage install links; records only locale, placement, and campaign tags, never selected text or account identifiers.',
  '首次验证漏斗': 'First Verify funnel',
  '隐私同意 → 插件打开 → 捕获选择 → 点击验证 → 发出请求 → 完成验证 → 看到结果；仅统计已同意数据使用说明的真实流量。': 'Privacy consent → extension opened → selection captured → Verify clicked → request started → verification completed → result viewed; counts only real traffic that accepted the data-use disclosure.',
  '查看来源详情': 'Source details opened',
  '用户在看到结论后主动展开支持来源、背景来源、冲突或证据缺口的次数。': 'Times users expanded supporting sources, background sources, conflicts, or evidence gaps after viewing the result.',
  '来源不匹配反馈': 'Source mismatch feedback',
  '用户明确反馈来源不适用或不相关；优先检查 Applicability Gate。': 'User feedback that sources were inapplicable or irrelevant; prioritize the Applicability Gate.',
  '当前事件证据不足': 'Current-event evidence gaps',
  '格式为证据不足或待复核 / 当前事件 Verify；观察时效性来源覆盖。': 'Format: source missing or review needed / current-event Verify; monitors coverage of timely sources.',
  '来源适用性拦截': 'Applicability rejections',
  '候选来源因主体、语境或来源类型不适用而被 Gate 排除的 Verify 次数。': 'Verify events where candidate sources were excluded because the entity, context, or source type did not apply.',
  '受控测试判定': 'Controlled test threshold',
  '仅用于阶段方向判断，不代表统计意义上的留存率或市场结论。': 'Used only for directional stage decisions; it is not a statistically meaningful retention rate or market conclusion.',
  '插件打开 → 发起首次验证 → 完成首次验证；统计已同意数据使用说明的 0.1.5 及以上版本用户。': 'Extension opened → first Verify started → first Verify completed; counts users on version 0.1.5 or later who accepted the data-use disclosure.',
  '上下文不足选择': 'Insufficient-context selections',
  '用户选择的片段缺少必要上下文；属于插件交互优化信号，不进入 KNE 来源缺口。': 'The selected fragment lacks required context; treat it as an extension UX signal, not a KNE source gap.',
  '首次验证完成率': 'First Verify completion rate',
  '目标 >= 40%；完成首次验证人数 / 插件打开人数。': 'Target >= 40%; users who completed their first Verify / users who opened the extension.',
  '24 小时二次验证率': '24-hour repeat Verify rate',
  '目标 >= 15%；观察首次价值是否促成短期再次使用。': 'Target >= 15%; measures whether first value leads to another Verify within 24 hours.',
  '匿名转注册': 'Anonymous-to-account conversion',
  '匿名完成首次验证后登录或注册的转化，不作为首次使用门槛。': 'Users who sign in or register after an anonymous first Verify; not a first-use requirement.',
  '有效反馈包': 'Valid feedback packages',
  '反馈提交转化': 'Feedback submission conversion',
  'Verify 版本分布': 'Verify version distribution',
  'Verify 客户端与版本分布': 'Verify client and version distribution',
  '客户端入口': 'Client channel',
  'Chrome 扩展': 'Chrome extension',
  'Edge 扩展': 'Edge extension',
  'Coze 插件': 'Coze plugin',
  '未知': 'Unknown',
  '插件版本': 'Extension version',
  'Build': 'Build',
  'Manifest': 'Manifest',
  '最近出现': 'Last seen',
  '暂无版本数据': 'No version data',
  '来源线索覆盖率': 'Source hint coverage',
  '有线索但未支持': 'Hints without support',
  '严重阻断问题': 'Severe blockers',
  '固定月成本': 'Monthly fixed cost',
  'Vultr 月成本': 'Vultr monthly cost',
  'Codex Pro 5x 月成本': 'Codex Pro 5x monthly cost',
  '其他月成本': 'Other monthly cost',
  '预计月 Verify': 'Projected monthly Verify',
  '预计月活跃验证用户': 'Projected monthly active verify users',
  '固定成本 / Verify': 'Fixed cost / Verify',
  '固定成本 / 活跃用户': 'Fixed cost / active user',
  '单次 Verify API 变量成本': 'Variable API cost / Verify',
  '单用户 API 变量成本': 'Variable API cost / user',
  '进入公开测试': 'Enter public beta',
  '扩大测试': 'Expand beta',
  '保留在 /admin': 'Kept in /admin',
  '用户、注册、邀请码、用量、日志、成本、系统和 Chrome Store 状态。': 'Users, registration, invite codes, usage, logs, costs, system status, and Chrome Store status.',
  '迁移到 /kneadmin': 'Moved to /kneadmin',
  'KNE 审核、来源库、Trust Policy、证据质量、冲突复核和知识库更新。': 'KNE review, source registry, Trust Policy, evidence quality, conflict review, and knowledge base updates.',
  '只有无邀请码普通注册用户占 200 名额。': 'Only ordinary public registrations without invite codes count toward the 200-user cap.',
  '审核期策略': 'Review-period policy',
  'Chrome Web Store 待审核期间不改插件包，只监控线上状态。': 'During Chrome Web Store review, do not change the extension package; only monitor online status.',
  '剩余 198 个普通公开注册名额。': '198 ordinary public registration slots remaining.',
  'Spark 1.x 历史账号和邀请码测试用户不占 200 名额。': 'Spark 1.x legacy accounts and invited testers do not count toward the 200-user cap.',
  '有效反馈包少于 30 份，用户判断依据不足。': 'Fewer than 30 valid feedback packages; user judgment evidence is insufficient.',
  'Chrome Web Store 审核期保持公开注册开启，达到上限自动停止。': 'Keep public registration open during Chrome Web Store review; stop automatically at the cap.',
  '公开测试名额已满，普通注册应显示等待名单提示。': 'Public beta slots are full; ordinary registration should show the waitlist prompt.',
  '公测核心指标只统计该时间之后的普通公开测试用户和行为；更早数据保留为测试/工程记录。': 'Public beta core metrics only count ordinary public beta users and activity after this time; earlier data remains as test and engineering records.',
  '名额触顶后统计等待名单人数，用于判断下一轮开放节奏。': 'Count waitlist users after the cap is reached to decide the next opening pace.',
  '运营重点': 'Ops focus',
  '关注注册、Verify 用量、限流、错误日志、成本与用户反馈。': 'Track registration, Verify usage, rate limits, error logs, costs, and user feedback.',
  '决策状态': 'Decision status',
  '先修阻断': 'Fix blockers first',
  '继续收集': 'Keep collecting',
  '监控优化': 'Monitor and improve',
  '可扩大测试': 'Ready to expand',
  '无数据': 'No data',
  '未采集': 'Not collected',
  '未配置': 'Not configured',
  '加载中': 'Loading',
  '条': 'items',
  '个': 'items',
  '份': 'packages',
  '次': 'times',
  '人': 'users',
  '天': 'days',
  '如 SPARK2026': 'e.g. SPARK2026',
  '如 研究圈': 'e.g. research circle',
  '暂无邀请码，点击「新建」创建': 'No invite codes. Click "New" to create one.',
  '使用此码注册的用户': 'Users registered with this code',
  '通用选中文本': 'Generic selected text',
  '通用选中文本验证': 'Generic selected-text verification',
  'AI 工作流': 'AI workflow',
  '普通网页': 'Ordinary web pages',
  '人工审核后推进': 'Advanced after human review',
  '旧 Knowledge 降级使用': 'Legacy Knowledge used as downgraded corpus',
  '不能直接支持主张': 'Cannot directly support claims',
  '实时状态': 'Live status',
  '依赖正常': 'Healthy dependencies',
  '镜像标记': 'Image tag',
  '当前镜像': 'Current image',
  '刷新状态': 'Refresh status',
  '服务': 'Service',
  '运行时长': 'Uptime',
  '公网 API': 'Public API',
  '全部正常': 'All healthy',
  '需要检查': 'Needs check',
  '公开名额': 'Public slots',
  '不占名额': 'Excluded from cap',
  'ready': 'Ready',
  'degraded': 'Degraded',
  'loading': 'Loading',
  'not loaded': 'Not loaded',

  'KNE 工作台': 'KNE Workspace',
  '贡献审核': 'Contribution Review',
  '来源缺口': 'Source Gaps',
  '证据片段': 'Evidence Segments',
  '证据片段复核': 'Evidence Segment Review',
  '核心候选复核': 'Core Candidate Review',
  '核心候选': 'Core candidates',
  '来源与证据': 'Source and evidence',
  '来源库': 'Source Registry',
  '可信策略': 'Trust Policy',
  '来源识别': 'Source Detection',
  '来源元数据': 'Source Metadata',

  'KNE 可信验证运营台': 'KNE Trust Verification Console',
  '只服务新的 Spark 设计：审核贡献、维护来源、观察可信策略效果，并支撑浏览器外挂进入真实用户测试。': 'Built for the new Spark design: review contributions, maintain sources, observe trust policy behavior, and support the browser extension in real user testing.',
  '注册账号': 'Accounts',
  '近 7 天新增': 'New in 7 days',
  '当前策略': 'Current policy',
  '公测期 KNEAdmin 边界': 'Public Beta KNEAdmin Boundary',
  '当前主线': 'Current focus',
  '外部 AI 输出的知识主张识别、来源判断、可信状态解释。': 'Identify knowledge claims in external AI outputs, evaluate sources, and explain trust states.',
  '人工队列': 'Human queue',
  '用户贡献、纠错和来源补充默认进入 Founder Review。': 'User contributions, corrections, and source additions enter Founder Review by default.',
  '数据边界': 'Data boundary',
  '隔离': 'Isolation',
  'KNE 主数据、Reference Corpus、用户私有空间分层处理。': 'KNE core data, Reference Corpus, and private user spaces are handled in separate layers.',
  '测试入口': 'Test entry',
  '验证用户在 AI 页面和普通网页中的主动选中文本 Verify 行为。': 'Verify active text-selection behavior on AI pages and ordinary web pages.',
  '已接入 pending review / accept / reject。': 'Supports pending review / accept / reject.',
  '展示权威来源、候选来源、适用 council 和证据类型；正式写入仍需人工复核。': 'Shows authoritative sources, candidate sources, applicable councils, and evidence types; formal writes still require human review.',
  '展示 Trust Policy v0、高风险边界、来源适用性和复核路径。': 'Shows Trust Policy v0, high-risk boundaries, source applicability, and review paths.',
  '当前记录 sourcePlatform、sourceUrl 和 title；不做默认 DOM 深适配。': 'Currently records sourcePlatform, sourceUrl, and title; no default deep DOM adaptation.',
  '第一阶段只记录轻量来源元数据，不做 DOM 深适配。': 'Phase 1 records lightweight source metadata only, without deep DOM adaptation.',

  '只展示结构化来源生成的 Evidence Segment 候选。当前阶段用于人工复核和 KNE Core 打样，不代表已认证。': 'Shows Evidence Segment candidates generated from structured sources only. This stage supports manual review and KNE Core prototyping; it does not mean certified knowledge.',
  '待复核片段': 'Segments pending review',
  '权威来源': 'Authoritative sources',
  '覆盖议会': 'Councils covered',
  'Review Queue': 'Review Queue',
  '全部来源': 'All sources',
  '全部 Council': 'All councils',
  '全部复核状态': 'All review statuses',
  '暂无可复核 Evidence Segment。': 'No Evidence Segment candidates to review.',
  '填写证据片段审核备注': 'Enter evidence segment review note',
  '标记 reviewed': 'Mark reviewed',
  '拒绝': 'Reject',
  '不可读内容已省略': 'Unreadable content omitted',
  '审核备注': 'Review note',
  '证据缺口': 'Evidence gaps',
  '背景来源': 'Context sources',
  '全部平台': 'All platforms',
  '全部动作': 'All actions',
  '当前没有待审核贡献。': 'No pending contributions.',
  '未提供来源链接': 'No source URL provided',
  'Claim / Signal': 'Claim / Signal',
  'Source': 'Source',
  'Source Hint': 'Source Hint',
  'Context': 'Context',
  '质疑': 'Challenge',
  '纠正': 'Correction',
  '填写审核备注，说明接受或拒绝的原因': 'Enter review note for accept or reject',
  '接受': 'Accept',
  '质疑主张': 'Challenge claim',
  '纠正主张': 'Correct claim',
  '补充来源': 'Add source',
  '提交主张': 'Submit claim',
  '支持主张': 'Support claim',
  '未找到用户': 'No users found',
  '待审核贡献': 'Pending contributions',
  '仅候选': 'candidate only',
  '需要编目': 'curation required',
  '候选来源占位': 'candidate source',
  '相关主张': 'Related claim',
  '提交人': 'Submitted by',
  '来源页面': 'Source page',
  '议会': 'Council',
  '次级议会': 'Secondary council',
  '证据': 'Evidence',
  '别名': 'Aliases',
  '主张': 'Claim',
  '主张 / 信号': 'Claim / Signal',
  '来源线索': 'Source Hint',
  '上下文': 'Context',
  '证据片段 ID': 'Evidence segments',
  '创建人': 'Created by',
  '创建复核草稿': 'Create Review Draft',
  '模板草稿': 'Review drafts',
  '已复核片段候选': 'Reviewed Segment Candidates',
  '复核草稿列表': 'Review Drafts',
  'Claim 文本': 'Claim text',
  '证据片段 ID 列表': 'segment:xxx, segment:yyy',
  '搜索候选 Claim / 来源 / Context': 'Search candidate Claim / Source / Context',
  '当前筛选下没有候选。': 'No candidates match the current filters.',
  'Claim、Evidence Segment 和 review note 都必须填写。': 'Claim, Evidence Segment, and review note are required.',
  '状态审核备注不能为空。': 'Status review note is required.',
  '二次复核备注不能为空。': 'Second review note is required.',
  '复核备注不能为空。': 'Review note is required.',

  '复核模板草稿': 'Review Template Drafts',
  '候选模板': 'Template Candidates',
  '创建模板': 'Create Template',
  '使用候选': 'Use Candidate',
  '标记 reviewed template': 'Mark reviewed template',
  '标记 core candidate': 'Mark core candidate',
  '拒绝模板': 'Reject template',
  '搜索 Claim / Council / Context': 'Search Claim / Council / Context',
  '全部模板状态': 'All template statuses',
  '全部可信状态': 'All trust states',
  '只有 draft 可以标记 reviewed。': 'Only draft templates can be marked reviewed.',
  '只有 reviewed_template 且具备复核路径的 source_supported 草稿可以进入 core candidate。': 'Only reviewed_template drafts with source_supported trust state and a review path can become core candidates.',
  'Core Candidate 复核': 'Core Candidate Review',
  '只导出候选给人工或 Claude 二次审核，不写入正式 KNE Core。': 'Export candidates for human or Claude second review only. This does not write formal KNE Core.',
  '暂无 core candidate。': 'No core candidates.',
  '导出审核包': 'Export review package',
  '导出中…': 'Exporting...',
  '收起导出': 'Collapse export',
  '填写二次复核备注': 'Enter second review note',
  '接受候选': 'Accept candidate',
  '二审通过': 'Pass second review',
  '暂缓候选': 'Hold candidate',
  '拒绝候选': 'Reject candidate',
  '终态候选': 'Terminal candidate',
  '该候选已完成二次复核，只保留导出和历史查看。': 'This candidate has completed second review. Only export and history remain available.',
  '已终态，不可继续推进。': 'Terminal status. It cannot advance further.',
  '核心候选必须通过二次复核处理。': 'Core candidates must be handled through second review.',
  '暂无候选模板。': 'No template candidates.',
  '暂无 reviewed segment 候选。': 'No reviewed segment candidates.',
  '暂无 KNE Core 模板草稿。': 'No KNE Core review drafts.',

  '已通过的用户来源贡献只进入候选区；完成人工编目和来源质量评估前，不能支持 KNE 可信判定。': 'Accepted user source contributions enter the candidate area only. They cannot support KNE trust decisions until manually cataloged and quality reviewed.',
  '来源缺口排行': 'Source Gap Ranking',
  '补源任务': 'Source Tasks',
  '处理中': 'In progress',
  '完成': 'Done',
  '忽略': 'Ignore',
  '批量备注（可选）': 'Bulk note (optional)',
  '批量处理中': 'Mark visible in progress',
  '批量完成': 'Mark visible done',
  '批量忽略': 'Ignore visible',
  '识别所属 council，定位缺失来源类型，优先接入权威来源': 'Identify the council, locate the missing source type, and prioritize authoritative sources',
  '补权威来源，保持人工复核': 'Add authoritative sources and keep human review',
  '生成任务': 'Generate Tasks',
  '暂无缺口数据': 'No source gap data',
  '公开测试监控': 'Public Beta Monitor',
  '名额使用': 'Slot usage',
  '当前预警': 'Current Warnings',
  '需要处理': 'Needs attention',
  '公测核心指标': 'Beta Core Metrics',
  '指标': 'Metric',
  '目标 / 解释': 'Target / explanation',
  '建议动作': 'Suggested action',
  '样例': 'Sample',
  '最近测试反馈': 'Recent Test Feedback',
  '反馈': 'Feedback',
  '暂无测试反馈': 'No test feedback',
  '最近阻断问题': 'Recent Blocking Issues',
  '区域': 'Area',
  '信息': 'Message',
  '次数': 'Count',
  '暂无阻断问题': 'No blocking issues',
  '标记已处理': 'Mark resolved',
  '阶段门槛': 'Stage Gates',
  '准备正式发布': 'Prepare official launch',
  '启动订阅': 'Start subscription',
  '来源缺口治理': 'Source Gap Governance',
  '缺口组': 'Gap groups',
  '高优先级': 'High priority',
  '来源线索覆盖': 'Source hint coverage',
  '线索未支持': 'Hints not supported',
  '数据来源': 'Data source',
  '涉及 Council': 'Related councils',
  '补源原则': 'Source expansion principle',
  '可支持': 'Support-capable',
  '来源数': 'Source count',
  '结构化片段来源': 'Structured segment sources',
  '来源库联动': 'Source Registry link',
  '最高频缺口': 'Top gap',
  '下一类来源': 'Next source type',
  '优先级': 'Priority',
  '领域': 'Domain',
  'Claim 类型': 'Claim type',
  '缺失来源类型': 'Missing source type',
  '任务': 'Task',
  '暂无来源缺口数据': 'No source gap data',
  '继续观察': 'Keep observing',
  '已建任务': 'Task exists',
  '时间': 'Time',
  '暂无补源任务': 'No source tasks',
  '暂无缺口 council。': 'No gap council.',
  'KNE 贡献审核': 'KNE Contribution Review',
  '超过 48h': 'Over 48h',
  '高价值线索': 'High-value leads',
  '保存草稿': 'Save draft',
  '填写状态推进备注': 'Enter status progress note',
  '线上已部署': 'Deployed online',
  '健康检查': 'Health checks',
  '当前职责': 'Current responsibility',
  '不占公开名额': 'Does not count toward public slots',
  '公开测试准备': 'Public beta preparation',
  '验证入口': 'Verify entry',
  '访问方式': 'Access method',
  '反馈入口': 'Feedback entry',
  '可公开注册': 'Public registration open',
  '已停用方向': 'Retired direction',
  '环境边界': 'Environment boundary',
  '后台边界': 'Admin boundary',
  '可信边界': 'Trust boundary',

  'KNE 治理状态迁移到 /kneadmin': 'KNE governance has moved to /kneadmin',
  'Spark Ops': 'Spark Ops',
  'KNE Admin': 'KNE Admin',
}

const ZH_TEXT = Object.fromEntries(Object.entries(EN_TEXT).map(([zh, en]) => [en, zh])) as Record<string, string>

const EN_FRAGMENTS: Record<string, string> = {
  '隔离': 'Isolation',
  '公开测试阶段只看真实用户行为：注册、激活、二次使用、Verify 频率、反馈质量、贡献流转、阻断问题和成本。': 'During public beta, focus only on real user behavior: registration, activation, repeat use, Verify frequency, feedback quality, contribution flow, blockers, and cost.',
  '普通公开测试用户上限。达到上限后停止普通注册，管理员和邀请测试保留。': 'Ordinary public beta user cap. Stop ordinary registration at the cap; admins and invited testers remain available.',
  '近 7 天新增账号。用于观察 Chrome Web Store 上线后的自然进入速度。': 'New accounts in the last 7 days. Used to observe organic intake after Chrome Web Store launch.',
  '公开测试用户中至少完成过 1 次 Verify 的人数。': 'Public beta users who completed at least one Verify.',
  '等待指标加载。': 'Waiting for metrics.',
  '已有数据但未达到扩大测试门槛，优先处理留存、反馈和 KNE Admin 中的来源缺口。': 'Data exists but has not reached the expansion threshold; prioritize retention, feedback, and source gaps in KNE Admin.',
  '上限 200 人；历史账号、管理员、邀请测试不占普通名额。': 'Cap is 200 users; legacy accounts, admins, and invited testers do not count.',
  '后台自动识别：7 天内在 ChatGPT、千问、Claude、豆包或 Gemini 页面触发 Verify 的用户。': 'Automatically detected: users who triggered Verify on ChatGPT, Qwen, Claude, Doubao, or Gemini pages in 7 days.',
  '目标 >= 40%；定义为注册后完成至少 1 次 Verify。': 'Target >= 40%; defined as at least one Verify after registration.',
  '目标 >= 20%；融资验证优先看回访，不只看安装。': 'Target >= 20%; fundraising proof prioritizes return use, not installs only.',
  '目标 >= 5 次；判断插件是否进入日常 AI 使用。': 'Target >= 5; judges whether the extension enters daily AI use.',
  '目标 >= 30 份；包含可靠性判断、来源强弱、理解难点、复用意愿。': 'Target >= 30 packages; includes reliability judgment, source quality, confusion points, and reuse intent.',
  '复制反馈包后真正提交的比例；用于判断反馈入口是否太重。': 'Ratio of copied feedback packages actually submitted; used to judge feedback friction.',
  '目标 >= 20 条；有实质知识内容的反馈再转入 KNE Review。': 'Target >= 20; substantive feedback moves to KNE Review.',
  'Verify 后至少给出来源线索的比例；用于观察“未知”是否仍有可行动方向。': 'Share of Verify results with source hints; checks whether unknown results still offer action.',
  '有候选来源方向但未进入 KNE 支持层；优先进入 source gap 补库。': 'Candidate source direction exists but has not entered KNE support; prioritize source gap expansion.',
  '目标 7 天内 0 个；优先修登录、Verify、限流、来源识别阻断。': 'Target 0 in 7 days; prioritize login, Verify, quota, and source detection blockers.',
  'Vultr、其他成本和 Codex Pro 5x 的月度固定投入合计。': 'Monthly fixed spend across Vultr, other costs, and Codex Pro 5x.',
  '服务器与云资源固定成本。': 'Fixed server and cloud resource cost.',
  '开发与运维使用的固定工具成本。': 'Fixed tool cost for development and operations.',
  '域名、VPN、企业邮箱等其它固定月成本。': 'Other fixed monthly costs such as domain, VPN, and business email.',
  '按最近 7 天 Verify 次数线性外推，仅用于公测成本观察。': 'Linear projection from recent 7-day Verify count; for beta cost observation only.',
  '按最近 7 天已验证用户线性外推。': 'Linear projection from recent 7-day verified users.',
  '固定月成本按预计月 Verify 摊销；公测早期会偏高。': 'Fixed monthly cost allocated by projected monthly Verify; high in early beta.',
  '固定月成本按预计月活跃验证用户摊销。': 'Fixed monthly cost allocated by projected monthly active verify users.',
  '来自 SPARK_BETA_VERIFY_UNIT_COST_USD；不包含服务器、其他固定成本和 Codex。': 'From SPARK_BETA_VERIFY_UNIT_COST_USD; excludes servers, other fixed costs, and Codex.',
  '只统计按 Verify 调用产生的变量成本。': 'Only counts variable cost generated by Verify calls.',
  'Chrome Web Store 通过审核；线上 API 稳定；公开注册开启；200 人 cap 生效。': 'Chrome Web Store approved; online API stable; public registration open; 200-user cap active.',
  '连续 7 天无严重阻断；反馈包达到 30 份；7 天二次验证率开始可读。': 'No severe blocker for 7 days; 30 feedback packages; 7-day repeat verify becomes readable.',
  '用户明确愿意继续使用；KNE source_supported 不过度乐观；成本曲线可控。': 'Users clearly want continued use; KNE source_supported is not over-optimistic; cost curve is controllable.',
  '免费用户形成使用习惯后再开启；$9.9/月 Pro 以更高查询额度和高级功能承接。': 'Start after free users form usage habits; $9.9/month Pro provides higher query limits and advanced features.',
  '按真实 Verify 缺口决定 KNE 下一步补源方向。用户验证行为只作为需求信号，不直接成为知识认证。': 'Use real Verify gaps to decide KNE source expansion. User verification behavior is only a demand signal, not knowledge certification.',
  '最近 7 天 Verify 事件。用于定位缺口，不用于直接认证知识。': 'Recent 7-day Verify events. Used to locate gaps, not to certify knowledge directly.',
  '十二议会中具备可支持来源的覆盖数量；只表示来源能力，不等于 KNE Core 认证。': 'Number of councils with support-capable sources; indicates source capability, not KNE Core certification.',
  '先补权威来源和可引用来源，候选来源不直接升级为 KNE 认证。': 'Add authoritative and citable sources first; candidate sources are not directly upgraded to KNE certification.',
  '每个 council 只记录三件事：能否支持 source_supported、最高频缺口、下一类应补来源。': 'Each council records only three things: whether it can support source_supported, top gap, and next source type.',
  'Spark 不认证“真理”，只输出当前 KNE 来源层能支持的可信状态、证据缺口和人工复核要求。': 'Spark does not certify truth; it outputs trust states, evidence gaps, and human review requirements supported by the current KNE source layer.',
  '存在可引用来源，且来源等级满足当前主张类型。': 'Citable sources exist and the authority level fits the claim type.',
  '未找到候选来源或来源不足以支持主张。': 'No candidate source found or sources are insufficient to support the claim.',
  '高风险、冲突、时效敏感或来源等级不足。': 'High risk, conflict, time sensitivity, or insufficient source level.',
  '候选来源之间存在直接冲突。': 'Direct conflict exists between candidate sources.',
  '证据可能过期，需要更新来源。': 'Evidence may be outdated and requires source update.',
  '医疗、安全、法律等领域默认进入强复核。': 'Medical, safety, legal, and similar domains enter strict review by default.',
  '第一阶段采用通用选中文本验证：用户主动选择 AI 或网页内容后验证；平台只做轻量来源识别，不维护 DOM 深适配。': 'Phase 1 uses generic selected-text verification: users actively select AI or web content to verify; platforms only get lightweight source detection without deep DOM adaptation.',
  '核心入口：用户主动选择文本后通过右键或 Side Panel 验证。': 'Core entry: users select text and verify through context menu or Side Panel.',
  '记录 sourcePlatform、sourceUrl 和标题，用于回溯验证场景。': 'Record sourcePlatform, sourceUrl, and title for verification traceability.',
  '覆盖 ChatGPT、千问、Claude、豆包、Gemini 等常用 AI 页面。': 'Covers common AI pages such as ChatGPT, Qwen, Claude, Doubao, and Gemini.',
  '支持资料页、文章页和搜索结果中的主动选中文本验证。': 'Supports active selected-text verification on documentation pages, articles, and search results.',
  '处理用户从 AI 使用现场提交的来源、纠错、质疑和知识主张。接受只代表进入 KNE 后续处理，不代表自动认证为真。': 'Review sources, corrections, challenges, and knowledge claims submitted from AI use. Acceptance only means entering later KNE processing, not automatic certification.',
  '用 reviewed Evidence Segment 组装 KNE Core 复核路径草稿。草稿只用于打样，不代表已进入正式 KNE Core。': 'Assemble KNE Core review path drafts from reviewed Evidence Segments. Drafts are prototypes only and do not mean entry into formal KNE Core.',
  '从 reviewed/supports 的 Evidence Segment 生成，点击后填入草稿表单。': 'Generated from reviewed/supports Evidence Segments; click to fill the draft form.',
  '面向 KNE 验证源、浏览器外挂、公开测试和数据边界的运营状态。旧聊天产品状态不再作为主监控对象。': 'Operational status for KNE verification sources, browser extension, public beta, and data boundaries. Legacy chat is no longer a primary monitoring object.',
  '面向浏览器外挂、公开测试、用户注册、用量限额和线上服务的运营状态。KNE 治理状态迁移到 /kneadmin。': 'Operational status for browser extension, public beta, registration, usage quota, and online services. KNE governance moved to /kneadmin.',
}

const ZH_FRAGMENTS = Object.fromEntries(Object.entries(EN_FRAGMENTS).map(([zh, en]) => [en, zh])) as Record<string, string>

const EN_PATTERNS: Array<[RegExp, (match: RegExpMatchArray) => string]> = [
  [/^剩余\s*(\d+)\s*个普通公开注册名额。$/, match => `${match[1]} ordinary public registration slots remaining.`],
]

function translateValue(value: string, locale: 'zh' | 'en'): string {
  const trimmed = value.trim()
  if (!trimmed) return value
  const dictionary = locale === 'en' ? EN_TEXT : ZH_TEXT
  if (dictionary[trimmed]) return value.replace(trimmed, dictionary[trimmed])
  const fragments = locale === 'en' ? EN_FRAGMENTS : ZH_FRAGMENTS
  let nextValue = value
  for (const [from, to] of Object.entries(fragments).sort((a, b) => b[0].length - a[0].length)) {
    nextValue = nextValue.split(from).join(to)
  }
  const phraseDictionary = locale === 'en' ? EN_TEXT : ZH_TEXT
  for (const [from, to] of Object.entries(phraseDictionary).sort((a, b) => b[0].length - a[0].length)) {
    if (from.length < 2) continue
    nextValue = nextValue.split(from).join(to)
  }
  if (nextValue !== value) return nextValue
  if (locale === 'en') {
    for (const [pattern, build] of EN_PATTERNS) {
      const match = trimmed.match(pattern)
      if (match) return value.replace(trimmed, build(match))
    }
  }
  return value
}

export function translateAdminText(value: string, locale: 'zh' | 'en') {
  return translateValue(value, locale)
}

export function useAdminCopy() {
  const { i18n } = useTranslation()
  const locale = i18n.language === 'en' ? 'en' : 'zh'
  return {
    locale,
    t: (value: string) => translateValue(value, locale),
  }
}

export function useAdminI18n(rootId: string) {
  const { i18n } = useTranslation()
  const locale = i18n.language === 'en' ? 'en' : 'zh'
  void rootId

  return {
    locale,
    t: (value: string) => translateValue(value, locale),
    switchLabel: locale === 'en' ? '中文' : 'EN',
    switchLocale: () => persistLocale(locale === 'en' ? 'zh' : 'en'),
  }
}
